import Vue from 'vue';
import VueFormulate from '@braid/vue-formulate/src/Formulate';
import {de} from '@braid/vue-formulate-i18n';
import FormulateEditor from '../components/Form/FormulateEditor';
import FormulateSelect from '../components/Form/FormulateSelect';
import FormulateMap from '../components/Form/FormulateMap';
import FormulateCropper from '../components/Form/FormulateCropper';

Vue.component('FormulateEditor', FormulateEditor);
Vue.component('FormulateSelect', FormulateSelect);
Vue.component('FormulateMap', FormulateMap);
Vue.component('FormulateCropper', FormulateCropper);

Vue.use(VueFormulate, {
    plugins: [de],
    locale: 'de',
    library: {
        editor: {
            classification: 'text',
            component: 'FormulateEditor',
        },
        multiselect: {
            classification: 'select',
            component: 'FormulateSelect',
        },
        map: {
            classification: 'select',
            component: 'FormulateMap',
            slotProps: {
                component: ['address', 'settings', 'visual'],
            },
        },
        cropper: {
            classification: 'file',
            component: 'FormulateCropper',
            slotProps: {
                component: ['aspectRatio'],
            },
        },
    },
    uploadUrl: '/api/merchant/upload',
    uploader: async function(file, progress, error, options) {
        const formData = new FormData();
        formData.append('file', file);

        return axiosInstance.post(options.uploadUrl, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: progressEvent => {
                progress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
            },
        }).then(res => res.data).catch(err => {
            if (!err.response?.data?.message) {
                return error(err);
            }

            error(err.response.data.message);
        });
    },
});
